import type { FaireProductEntity } from "../../entity_types/product";

export const p_8k68rxr7cu: FaireProductEntity = {
  token: "p_8k68rxr7cu",
  type: "product",
  name: "Beaded necklace with Miyuki beads with charms - green/salmon",
  brandToken: "b_9qv2bhnwv6",
  brandName: "Bazou",
  imageUrl:
    "https://cdn.faire.com/fastly/5f4defa88e07a35959467767a68b41451d388fb5fd846d3519414395c7706887.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9563c726dd0464fc3bd161ef56b9c229a41e904aaf4fef3734ad9d30cde86842.jpeg",
    "https://cdn.faire.com/fastly/9cc456370b65b8235bf90879e05c6ff63cbe125357d1229862641b57b1043c7e.jpeg",
  ],
  priceDollars: 15.67,
  description:
    "Hot item alert! Beads are the trend of the moment and we can't wait to share this with you! The XL beaded necklace is a must-have for your jewelry collection. Thanks to the chunky beads and bright colors, this statement necklace goes with every outfit. Wear it solo and spice up your look, girl!\n\n- This necklace is made of high-quality beads\n- The clasp is made of premium stainless steel, so it does not tarnish!\n- The necklace is 44 cm long & not adjustable\n- The clasp has a diameter of 1.4 cm",
  tags: [],
  msrpDollars: 37.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:46.575Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
